import React, { useEffect, useRef, useState } from 'react';

import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { RadioButton } from "primereact/radiobutton";
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { ColorPicker } from 'primereact/colorpicker';
import { ConfirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Api } from '../../../services/api';
import { FaCopy, FaPencilAlt, FaTrash } from 'react-icons/fa';
import { BiPlusMedical } from 'react-icons/bi';
import { FileUpload } from 'primereact/fileupload';
import { InputTextarea } from "primereact/inputtextarea";

const Organization = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [orgType, setOrgType] = useState([]);
    const [searchOrgType, setSearchOrgType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const toast = useRef(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);

    // -------------------------------------------------------------
    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const [pageNumber, setPageNumber] = useState(0);
    const projectsPerPage = 5;
    const pagesVisited = pageNumber * projectsPerPage;
    const [type, setType] = useState('Add');
    const [title, setTitle] = useState('Add Project Type');
    const [orgTypeID, OrgTypeID] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');

    // -------------------------------------------------------------

    const formik = useFormik({
        initialValues: {
            title: '',
            first_name:'',
            last_name:'',
            status: 'Y',
            password: '',
            email: '',
            image: null,
            //   color_code: '',

        },
        validate: (data) => {
            let errors = {};

            if (!data.title) {
                errors.title = 'Title is required.';
            }

            if (!data.email) {
                errors.email = 'Emil is required.';
            }

            if (!data.password) {
                errors.password = 'Password is required.';
            }
            // if (!data.image) {
            //     errors.image = 'Image is required.';
            // }

            return errors;
        },
        onSubmit: (data) => {
            // Determine the URL based on the type
            let url = Api.API_BASE_URL + 'add-organization';
            if (type === "Edit") {
                url = Api.API_BASE_URL + 'update-organization/' + orgTypeID;
            }

            // Retrieve the token from localStorage
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };

            // Perform the fetch request with the updated headers
            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((json) => {
                    if (json.error) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: json.error });
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: json.result });
                        closeModal();
                        getOrgType();
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });

            console.log(data);
        }

    });
    // -------------------------------------------------------------



    const openModal = () => {
        OrgTypeID('');
        formik.resetForm();
        setType('Add');
        setTitle('Add Project Type');
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
    };


    const customBase64Uploader = async (event) => {
        // convert file to base64 encoded
        const file = event.files[0];

        const fileType = file.type;
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

        if (!allowedTypes.includes(fileType)) {
            alert('File format not supported. Only JPG, JPEG, and PNG are allowed.');
            return;
        }


        const reader = new FileReader();
        let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url

        reader.readAsDataURL(blob);

        reader.onloadend = function () {
            let base64data = reader.result;
            // base64data = base64data.replace("data:image/png;base64,", "");
            formik.setFieldValue("image", base64data);
            console.log("base64data", base64data);
        };
    };


    const editModal = (row) => {

        OrgTypeID(row.id);
        formik.setFieldValue('title', row.title);
        formik.setFieldValue('first_name', row.first_name);
        formik.setFieldValue('last_name', row.last_name);
        formik.setFieldValue('description', row.description);
        formik.setFieldValue('status', row.status);
        formik.setFieldValue('email', row.email);
        formik.setFieldValue('image', row.image);
        formik.setFieldValue('password', 'password');

        setType('Edit');
        setTitle('Edit Project Type');
        setIsModalOpen(true);
    };

    const [orgShow, setOrgShow] = useState("N");

    useEffect(() => {
        console.log('Fetching projects...xx');
        var organizationId =    localStorage.getItem('organizationId');
        if(organizationId=="66f6989c2191596fe7f1c46f" || organizationId=="66f16bb68657dd00c9332538" ){
            setOrgShow("Y");
             
        }
        getOrgType();
    }, []);

    const getOrgType = (project) => {
        // Retrieve the token from localStorage
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Authorization': token ? `Bearer ${token}` : ''
        };

        // Make the GET request with token in the Authorization header
        axios.get(Api.API_BASE_URL + 'get-all-organization', { headers })
            .then((response) => {
                const data = response.data.result;
                setOrgType(data);
                setSearchOrgType(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });
    };




    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div onClick={(e) => e.stopPropagation()}>
                   {orgShow=="Y"? (<FaTrash onClick={() => handleDeleteProject(rowData.id)} style={{ color: 'darkred' }} />):null}
                </div>
            </React.Fragment>
        );
    };

    const handleDeleteProject = (projectId,) => {
        OrgTypeID(projectId);
        setIsDeleteConfirmationModalOpen(true);
    };


    const confirmDelete = async () => {
        // Retrieve the token from localStorage
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Authorization': token ? `Bearer ${token}` : ''
        };

        // Make the GET request with token in the Authorization header
        try {
            const response = await axios.get(Api.API_BASE_URL + 'delete-organization/' + orgTypeID, { headers });
            toast.current.show({
                severity: 'info',
                summary: 'Confirmed',
                detail: response.data.result,
                life: 3000
            });
            getOrgType();
            closeModal();
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };


    const showColor = (showColor) => {
        return (
            <div className="p-d-flex p-ai-center">
                <div className="p-d-block p-ml-2 p-px-3 " style={{ backgroundColor: '#' + showColor, width: "50px", height: "20px", textAlign: 'center' }}></div>
            </div>
        )

    }

    const searchrole = (searchValue) => {
        console.log('searchValue', searchValue);
        setOrgType([]);
        const searchResult = searchOrgType.filter((item) =>
            item.name.toLowerCase().includes(searchValue.toLowerCase())
        );

        setOrgType(searchResult);
        console.log(searchResult)
    }



    const header = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-0 ">
            <h4 className="m-0 px-2 table-header">Organization Name</h4>
            <div>
                <span className="p-input-icon-left ">
                    <InputText className="input-field m-1" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search..." />
                </span>
                {orgShow=="Y"?( <button type="button" title='Add a new Project Type' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
                    <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
                        <BiPlusMedical size={14} />
                        <span> ADD </span>
                    </div>
                </button>):null} 
                
               {/* <button type="button" title='Add a new Project Type' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
                    <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
                        <BiPlusMedical size={14} />
                        <span> ADD </span>
                    </div>
                </button> */}
            </div>

        </div>
    );


    const onRowSelect = (e) => {
        const rowData = e.data;
        editModal(rowData);
    };
    const statusBodyTemplate = (rowData) => {
        return rowData.status === 'Y' ? 'Active' : 'In-Active';
    };


    return (
        <>
            <div className="pagee-container mt-2">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <DataTable

                            value={orgType}
                            paginator
                            rows={14}
                            key="id"
                            tableStyle={{ minWidth: '50rem' }}
                            selectionMode="single"
                            selection={selectedProduct}
                            onRowSelect={onRowSelect}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            header={header}
                            globalFilter={globalFilter || ''}
                            emptyMessage="No records found"
                        >

                           <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', alignItems: 'center', textAlign: 'center' }}></Column>
                            <Column field="title" header="Organization Name" ></Column>
                            <Column field="status" header="Status" body={statusBodyTemplate} />

                        </DataTable>
                    )}
                </div>
            </div>
            {/* ---------------------------------------------------------------*/}

            <Dialog header="Organization" visible={isModalOpen} maximizable style={{ width: '30vw' }} dismissableMask="true" onHide={() => { setIsModalOpen(false); setSelectedProduct(null); }}>
                <div className='p-2'>
                    <form onSubmit={formik.handleSubmit} className="" >


                        <div className="mt-2 p-2">

                            <div className='mt-3'>
                                <label className='card-heading'>Organization Name:</label>
                                <InputText
                                    id="title"
                                    name="title"
                                    value={formik.values.title}
                                    onChange={(e) => {
                                        console.log(e.target.value);
                                        formik.setFieldValue('title', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('title') })} style={{ width: '100%' }}
                                />
                            </div>
                            <div className='flex mt-3 gap-2'>
                            <div>
                                <label className='card-heading'>First Name</label>
                                <InputText
                                    id="first_name"
                                    name="first_name"
                                    value={formik.values.first_name}
                                    onChange={(e) => {
                                        console.log(e.target.first_name);
                                        formik.setFieldValue('first_name', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('first_name') })} style={{ width: '100%' }}
                                />
                            </div>
                            <div>
                                <label className='card-heading'>Last Name</label>
                                <InputText
                                    id="last_name"
                                    name="last_name"
                                    value={formik.values.last_name}
                                    onChange={(e) => {
                                        console.log(e.target.value);
                                        formik.setFieldValue('last_name', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('last_name') })} style={{ width: '100%' }}
                                />
                            </div>
                            </div>

                            <div className='mt-3'>
                                <label className='card-heading'>Email</label>
                                <InputText
                                    id="email"
                                    name="email"
                                    value={formik.values.email}
                                    disabled={type == 'Edit' ? true : false}
                                    onChange={(e) => {

                                        formik.setFieldValue('email', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('email') })} style={{ width: '100%' }}
                                />
                            </div>

                            {type == 'Edit' ? null :
                                <div className="mt-2">
                                    <label className='card-heading'>Password</label>
                                    <InputText
                                        id="password"
                                        name="password"
                                        value={formik.values.password}
                                        onChange={(e) => {
                                            console.log(e.target.value);
                                            formik.setFieldValue('password', e.target.value);
                                        }}
                                        className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('password') })} style={{ width: '100%' }}
                                    />
                                </div>
                            }

                            <div className='mt-3'>
                                <label className='card-heading'>Organization Description</label>
                                <InputTextarea
                                    id="description"
                                    name="description"
                                    rows={5}
                                    value={formik.values.description}
                                    onChange={(e) => {
                                        console.log(e.target.value);
                                        formik.setFieldValue('description', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('description') })} style={{ width: '100%' }}
                                />
                            </div>

                            <div className='flex'>
                                <div className="col-6  mt-3">
                                    <label className='card-heading'>Status</label>
                                    <div>
                                        <RadioButton inputId="ingredient1" name="status" value="Y" onChange={(e) => formik.setFieldValue('status', e.target.value)} checked={formik.values.status === 'Y'} />
                                        <label htmlFor="ingredient1" className="ml-2">Active</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <RadioButton inputId="ingredient2" name="status" value="N" onChange={(e) => formik.setFieldValue('status', e.target.value)} checked={formik.values.status === 'N'} />
                                        <label htmlFor="ingredient2" className="ml-2">In-Active</label>
                                    </div>
                                </div>

                                <div className="col-6 mt-3">
                                    <h3 className='card-heading'>Organization Logo</h3>

                                    <div className=' pt-2  ' style={{ display: 'flex', flexDirection:'column',  alignItems:'center' }}>
                                        {formik.values.image ?
                                            <div className=" p-2 ">
                                                <img height={100} width={100} src={`${formik.values.image}`} />
                                            </div>
                                            : <div className="p-2">
                                                <img height={100} width={100} src={`https://cdn-icons-png.flaticon.com/512/2270/2270665.png`} />
                                            </div>
                                        }

                                        <div className="">
                                            <FileUpload mode="basic" name="demo[]" accept="image/*" className='m-2' chooseLabel="Choose File" onSelect={customBase64Uploader} style={{ fontSize: '18px', fontWeight: 'bold' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="col-12">
                                <div className="flex  justify-content-center mt-5">
                                    <Button label="Submit" type="submit" className='p-2 customSave-button' />
                                </div>
                            </div>


                        </div>





                    </form>

                </div >
            </Dialog >





            {/* ---------------------------------------------------------------*/}
            {
                isDeleteConfirmationModalOpen && (
                    <div className="modal">
                        <div className="small-modal-content">
                            <div className="modal-headerx">
                                <h5 className="modal-title">Delete Confirmation</h5>
                                <button className="modal-closex" onClick={closeModal}>
                                    &times;
                                </button>
                            </div>
                            <div className="modal-bodyx">
                                <p>"Are you sure you want to delete this Organization? "</p>
                            </div>
                            <div className="modal-footer-cancelx">
                                <button className="cancel-buttonx" onClick={closeModal}>
                                    Cancel
                                </button>
                                <button className="delete-buttonx" onClick={confirmDelete}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default Organization